import { ListViewItem } from '@ingka/list-view';
import documentPencil from '@ingka/ssr-icon/paths/document-pencil';
import { translate } from '@repo/phrase';

import { useSignRequestsSummary } from '../docusign-modal.hooks';

interface Props {
    onOpen: () => void;
}

export const SignaturesListItem = ({ onOpen }: Props) => {
    const { summaryText } = useSignRequestsSummary();

    const description =
        typeof summaryText === 'string' && summaryText.length > 0
            ? summaryText
            : translate('docusign_no_signature_requested');

    return (
        <ListViewItem
            id="asset-signatures"
            control="navigational"
            emphasised
            leadingIcon={documentPencil}
            title={translate('orderview_signatures_title')}
            description={description}
            onClick={onOpen}
            controlIcon="chevronRight"
            showDivider
        />
    );
};
